import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect } from 'react';
import { Modal, Button, Tooltip, OverlayTrigger, } from 'react-bootstrap';

const LocationModal = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [locationUrl, setLocationUrl] = useState('');
    const [latLng, setLatLng] = useState(null);
    const [address, setAddress] = useState('');

    useEffect(() => {
        if(data.location_url){
            setLocationUrl(data.location_url);
        }
    }, [data]);

    // Extract lat/lng from pasted URL
    const extractLatLngFromUrl = (url) => {
        const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
            return {
                lat: parseFloat(match[1]),
                lng: parseFloat(match[2]),
            };
        }
        return null;
    };
    const [errors, setErrors] = useState({});

    // On URL change, parse coordinates
    useEffect(() => {
        if(locationUrl) {
            const coords = extractLatLngFromUrl(locationUrl);
            if (coords) {
                setLatLng(coords);
                errors.loc = "";
            } else {
                setLatLng(null);
                errors.loc = "Not a Valid Location URL.";
            }
        }
    }, [locationUrl]);

    const validate = () => {
        const newErrors = {};
        
        if (locationUrl == '' && !locationUrl) {
            newErrors.loc = "This Field is Required.";
        } else if (!latLng) {
            newErrors.loc = "Not a Valid Location URL.";
        }


        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { latitude: latLng.lat.toString(), longitude: latLng.lng.toString(), location_url: locationUrl};
        axios.put(`${baseURL}/managelead/update_location/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Location Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Location Updation Failed");
            });

    };


    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Add Location</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">

                        <div className='col-lg-12 mb-3'>
                            <div className="row">
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                    <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                                    <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                                    <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                    <label className='text-black fs-6 font-w500'>{data.mobile_no}</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Location URL <span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Paste Google Maps location URL" value={locationUrl} onChange={(e) => setLocationUrl(e.target.value)}/>
                            {errors.loc && <div className="text-danger fs-8 mt-1">{errors.loc}</div>}
                        </div>


                        {latLng && (
                            <div className="mb-3">
                                <iframe
                                    title="Location Map"
                                    width="100%"
                                    height="300"
                                    style={{ border: 0, borderRadius: '10px' }}
                                    loading="lazy"
                                    allowFullScreen
                                    src={`https://www.google.com/maps?q=${latLng.lat},${latLng.lng}&z=15&output=embed`}
                                ></iframe>
                            </div>
                        )}

                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Add Location <i className="fas fa-angle-double-right ms-2"></i>
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default LocationModal;

